import {
  FETCH_BOOKINGS,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILED,
  UPDATE_BOOKING,
  CANCEL_BOOKING,
  USER_SIGN_OUT
} from "../store/types.js";

const INITIAL_STATE = {
  bookings: null,
  active: null,
  tracked: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const bookingslistreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS:
      return {
        ...state,
        loading: true
      };
    case FETCH_BOOKINGS_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case FETCH_BOOKINGS_FAILED:
      return {
        ...state,
        bookings: null,
        active:null,
        tracked:null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    case UPDATE_BOOKING: {
      const updated = action.payload;
      if (!updated || (!updated.id && !updated.bookingId)) {
        return state;
      }
      const targetId = updated.id || updated.bookingId;
      const statusUpper = String(updated.status || '').toUpperCase().trim();
      const tripStatusUpper = String(updated.trip_status || '').toUpperCase().trim();
      const isFinished = ['COMPLETED', 'COMPLETE', 'CANCELLED', 'PAID', 'REJECTED', 'EXPIRED'].includes(statusUpper) ||
                         ['COMPLETED', 'COMPLETE', 'CANCELLED', 'PAID', 'REJECTED', 'EXPIRED'].includes(tripStatusUpper);

      const bookings = state.bookings
        ? state.bookings.map((b) =>
            b.id === targetId || b.bookingId === targetId ? { ...b, ...updated } : b
          )
        : state.bookings;

      const active = state.active
        ? isFinished
          ? state.active.filter((b) => b.id !== targetId && b.bookingId !== targetId)
          : state.active.map((b) =>
              b.id === targetId || b.bookingId === targetId ? { ...b, ...updated } : b
            )
        : state.active;

      const tracked =
        state.tracked && (state.tracked.id === targetId || state.tracked.bookingId === targetId)
          ? isFinished
            ? null
            : { ...state.tracked, ...updated }
          : state.tracked;

      return {
        ...state,
        bookings,
        active,
        tracked,
      };
    }      
    case CANCEL_BOOKING:
      return {
        ...state
      };
    case USER_SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};